/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
    <br><br>
  <div>
  <div class="formPosition">
            <v-card style="margin:auto;" width="900px">

              <template >

                  <v-toolbar color="grey lighten-2">

           <v-row>
                    <v-col sm="4" cols="12" md="4">

    </v-col>

     <v-col sm="4" cols="12" md="6">  <!--  form titlte section   {{ formTitle }}-->
  <span> Cadastro de Séries</span>

     </v-col>

  </v-row>

                  </v-toolbar>

              </template>

 <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >

              <v-card-text>

                <v-container  >

<div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

                  <v-row>
                    <v-col  cols="12" md="6">
                       <v-text-field
                        :rules="ruleNumber"
                        v-model="serie"
                        label="Série"
                      ></v-text-field>
                    </v-col>
                    <v-col  cols="12" md="6">
                       <v-text-field
                        :rules="ruleRequired"
                        v-model="descricao"
                        label="Descrição"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
              <v-col md="4"></v-col>
              <v-col md="4"></v-col>
              <v-col md="2"><!--<v-btn fab   color="success"      @click="close"><v-icon large >edit</v-icon></v-btn>-->
              </v-col>
              <v-col md="2">
                  <v-btn    :disabled="!valid && novo"  fab        color="success"    @click="save"><v-icon large   >send</v-icon></v-btn>

              </v-col>
            </v-row>
                            </v-container>
              </v-card-text>

</v-form>

            </v-card>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],

    progresso: false,
    novo: false,
    valid: true,
    ano_actual: ls.get('anolectivo'),
    startDate: null,
    dataInicial: null,
    dataFinal: null,
    serie: null,
    precos: [],
    cursos: [],
    classes: [],
    propinas: [],
    documentos: [],
    classesFiltered: [],
    classeSelected: null,
    cursoSelected: null,
    isLoading: false,
    numeroInicial: null,
    numeroFinal: null,
    descricao: '',
    servico: '',
    cor: '',

    searchInDb: '',
    preco: 0,
    valorFormatado: '',
    valorConvertido: '',
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'Invalido.'
      }
    ],
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    headers: [
      {
        text: 'Curso',
        align: 'left',
        sortable: false,
        value: 'curso'
      },

      { text: 'Classe', value: 'classe' },
      { text: 'Preço', value: 'preco' },
      { text: 'data cadastro', value: 'data_' },
      { text: 'Autor', value: 'autor' }

    ],
    msg: '',
    editedIndex: -1

  }),

  computed: {

    loggedUserName () {
      return ls.get('nomeUsuario')
    },

    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initializeDocumento()
  },

  methods: {
    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL

    async initializeDocumento () {
      try {
        this.isLoading = true
        this.documentos = await axios
          .get('/documentos')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
        console.log(this.cursos)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializePrecosPropina () {
      try {
        this.isLoading = true
        this.precos = await axios
          .get('/precoPropinasFindAll')
          .then(res => res.data)
        console.log(this.precos)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeClasses () {
      try {
        this.isLoading = true
        this.classes = await axios
          .get('/classeFindAll')
          .then(res => res.data)
        console.log(this.classes)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    loadclasse () {
      this.classesFiltered = this.classes.filter(c => c.fk_curso === this.cursoSelected.pk_curso)
    },

    chamaDialogo () {
      this.dialog = true
    },

    close () {
      this.dialog = false
      this.$refs.form.reset()
    },
    ObterValorFormatado (valor) {
      let formated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'AOA' }).format(valor)
      this.valorFormatado = formated.toString().replace('AOA', '')
    },

    async save () {
      if (this.$refs.form.validate()) {
        this.progresso = true
        this.ObterValorFormatado(this.preco)
        let params =
        {
          pk_definir_precario_propina: 0,
          fk_classe: this.classeSelected.pk_classe,
          preco: parseInt(this.preco),
          autor: ls.get('nomeUsuario'),
          valor: this.valorFormatado + 'Akz'
        }

        let paramsTabela =
       {
         curso: this.cursoSelected.nome,
         classe: this.classeSelected.nome,
         preco: this.valorFormatado + 'Akz',
         autor: ls.get('nomeUsuario'),
         data_: new Date()
       }

        let precoExistente = this.precos.filter(p => p.pk_classe === this.classeSelected.pk_classe && p.status_definir_precario_propina === 1)
        if (!precoExistente.length) {
          try {
            let corMensagem = 'msgError'
            let msg = await axios
              .post('/precoPropinaInsertOrUpdate', params)
              .then(res => res.data)
            this.progresso = false

            if (msg.length) {
              corMensagem = 'msgError'
              this.text = 'Ocorreu um erro ao tentar efectuar a operação'
            } else {
              corMensagem = 'msgSucess'
              this.text = 'Operação efectuada com sucesso'
              this.propinas.unshift(paramsTabela)
              this.close()
            }
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': corMensagem, 'timeout': 5000 })
          } catch (error) {
            this.progresso = false
            this.text = error
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
          }
        } else {
          this.progresso = false
          this.text = 'Ja foi definido o valor da mensalidade para este curso e classe!'
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 4000 })
        }
      }
    }
  }
}
</script>
<style scoped>

.bg {
 color:green;
 background: red
}

</style>
